
class trackerActions {

	constructor(args)
		{
			this.usingTracker = false;
			this.currentUserData = JSON.parse(localStorage.getItem("userData"));
			this.whiteboardValues = this.currentUserData.whiteboardValues;
			this.onDemand = window['onDemand'];
			this.guestUser = window['guestUser'];
			this.electron = window['electron'];
			this.sep = '~@$';
			this.id = args['user_id'];
			this.tracker = {};
			this.alreadyIsChecking = false;
			this.trackerDef = false;
			this.trackerData = '';
			this.startRecTime = (new Date()).getTime();
			this.partLeft = 0;
			this.partRight = 0;
			this.partTop = 0;
			this.partBottom = 0;
			this.segLeft = 0;
			this.segRight = 0;
			this.segTop = 0;
			this.segBottom = 0;
			this.trackerX = 0;
			this.trackerTop = 0;
			this.trackerBottom = 0;
			this.trackerXL = 0;
			this.trackerSide = 0;
			this.trackerX2 = 0;
			this.trackerTop2 = 0;
			this.trackerBottom2 = 0;
			this.lastHitBagY = 0;
			this.boxLineTouched = false;
			this.totalTimeRestart = 0;
			this.pauseDetectorBackground = false;
			this.finalPositionTimeout = 0;
			this.trackerPointX = 0;
			this.trackerPointTop = 0;
			this.trackerPointBottom = 0;
			this.trackerInitialized = false;
			this.isTrackerBgSet = false;
			this.canvasWidthDiff = 2;
			this.trackerBorken = false;
			this.left_extrema = {};
			this.right_extrema = {};
			this.plankLineTouched = false;
			this.trackerTouched = false;
			this.trackerTouched2 = false;
			this.detectorColor = 'green';
			this.detectorColor2 = 'green';
			this.setTrackerBackground = true;
			this.detectorX = 0;
			this.detectorSet = [];
			this.detectorSetInfo = [];
			this.checkAnimation = true;
			this.canvasWidthTracker = 640 / 1280;
			this.canvasTrackerWidth = 1280 / 640;
			this.trackerStandInZone = false;
			this.hostVirtual = false;
			this.hostVirtualOnMember = false;
			this.memberNoHostVirtual = false;
			this.mediaPipeFreezeCount = 0;
			this.mediaPipeFreezeCountRoomSetup = 0;
			this.turnMediaPipeOnAgain = false;
			this.turnOffMediaPipe = false;
			this.previousMediaPipePoints = [];
			
			if ( args['host_virtual'] )
				{
					this.hostVirtual = true;
					console.log('load host virtual');
				}
			
			if ( args['host_virtual_member'] )
				{
					this.hostVirtualOnMember = true;
				}
			
			if ( args['host_virtual_ondemand'] )
				{
					this.memberNoHostVirtual = true;
				}
				
			if ( this.electron )
				{
					if ( ( (window['hasConeScript'] && (this.guestUser || this.hostVirtual)) || window['preStreamingWhite'] || this.onDemand ) || ( this.guestUser && this.currentUserData.sessionData.calculateAssessmentDimensions == 1 ) && !window['userCameraOff'] )
						{
							var track = window['whiteTracker'];
							console.log(track, 'track');
							this.tracker = track.addOn;
							if ( !window.trackerInitialized ) { this.tracker.initialize(); window.trackerInitialized = true; }
							console.log('tracker_info --> TRACKER INITIALIZE (at beginning)');
							console.log("tracker", this.tracker);
							this.trackerBorken = false;
							this.usingTracker = true;
							if ( window['startManualRecordingTest'] && !window['tisRecording'] ) { setTimeout(function () { window['startManualRecordingTestF'](); }, 500); }
						}
				}
				
			if ( (this.guestUser && !this.hostVirtualOnMember) || this.hostVirtual || (this.onDemand && !this.memberNoHostVirtual) )
				{
					window['setRegion'] = this.setRegion;
					window['trackerMovement'] = this.trackerMovement;
					window['setQuadTrackerZone'] = this.setQuadTrackerZone;
					window['trackerSetSides'] = this.trackerSetSides;
					window['setDetectorsPosition'] = this.setDetectorsPosition;
					window['setBackgroundDetector'] = this.setBackgroundDetector;
					window['trackerSetSideLimits'] = this.trackerSetSideLimits;
					window['setImageBackground'] = this.setImageBackground;
					window['checkInZoneMediaPipe'] = this.checkInZoneMediaPipe;
					window['setImageBackgroundFromCanvas'] = this.setImageBackgroundFromCanvas;
					window['disableMediaPipe'] = this.disableMediaPipe;
					window['toggleMediaPipe'] = this.toggleMediaPipe;
					window['pauseMediaPipe'] = this.pauseMediaPipe;
					window['switchToNextRoomStep'] = this.switchToNextRoomStep;
				}
		}
		
	async getParticipantPosition()
		{
			if ( !this.guestUser && !this.onDemand && !this.hostVirtual) { return false; }
			if ( this.trackerBorken ) { return false; }
			if ( this.alreadyIsChecking ) { return false; }
			this.alreadyIsChecking = true;
			var canvasWidthDiff = this.whiteboard.canvas.width / 640;
			var canvasHeightDiff = this.whiteboard.canvas.height / 360;
			var mainthis = this;
			
			if ( this.electron )
				{
					var bufferDraw = this.whiteboard.ctx4.drawImage(this.whiteboard.imageCanvas,0,0,this.whiteboard.bufferCanvas.width,this.whiteboard.bufferCanvas.height);
					var pixelBuff = this.whiteboard.ctx4.getImageData(0, 0, this.whiteboard.bufferCanvas.width, this.whiteboard.bufferCanvas.height);
					
					var uint8ClampedArray = pixelBuff.data;
					this.whiteboard.arrayBuffer = uint8ClampedArray.buffer;
					
					try
					{
						var trackerInfo = this.tracker.update(this.whiteboard.arrayBuffer, true);
					}
					catch (err)
					{
						console.error('TRACKER ERROR -- TRACKER UPDATE');
						console.error(err);
						window.$('#tracker-error').modal('show');
						this.trackerBorken = true;
						//window['saveCurrentCanvasAsPNG']('crash');
					}
					
					if ( !trackerInfo || !trackerInfo['seg_box'] ) { this.alreadyIsChecking = false; return false; }
					
					var box = trackerInfo['bounding_box'];
					var seg = trackerInfo['seg_box'];
					var useDefaultSegBox = false;
					
					this.checkFeetTracker(trackerInfo, canvasHeightDiff, canvasWidthDiff);
					
					/* console.log('getParticipantPosition 1');
					console.log(this.whiteboard.useMediaPipe);
					console.log('getParticipantPosition 2');
					console.log(this.whiteboard.roomSetup.roomSetupCompleted); */
					
					if ( !window['shownCameraPopup'] && !this.turnOffMediaPipe && window['usingPose'] && this.whiteboard.useMediaPipe && this.whiteboard.roomSetup.mediaCircleCompleted && (!window.lastFreezeTime || window.lastFreezeTime < (new Date().getTime() - parseInt(this.whiteboardValues['mediaPipeWaitTime']))) ) 
						{ 		
							let timeBeforeResults = new Date().getTime();			
							
							trackerInfo['mediaPipe'] = await this.whiteboard.poseDetection.getNewPoseAsync(this.whiteboard.bufferCanvas);
							
							if ( trackerInfo['mediaPipe'].length > 0 ) { mainthis.previousMediaPipePoints = trackerInfo['mediaPipe']; }
							else if ( mainthis.previousMediaPipePoints ) { trackerInfo['mediaPipe'] = mainthis.previousMediaPipePoints; console.log('use previousMediaPipePoints', mainthis.previousMediaPipePoints); }
							
							let timeDiff = new Date().getTime() - timeBeforeResults;
							//console.log('timeDiff', timeDiff);
							if ( timeDiff > parseInt(this.whiteboardValues['mediaPipeFreezeTime']) && !trackerInfo['mediaPipe'][0] )
								{
									window.lastFreezeTime = new Date().getTime();
									this.mediaPipeFreezeCount++;
									
									//this.whiteboard.showMessageInstruction('We encountered an issue, you may have issues during Virtual activities');
									var recalibrationHidden = JSON.parse(localStorage.getItem('recalibrationHidden')).value;
									console.log('recalibrationHidden', recalibrationHidden);
									if ( window.calculatingAR && !recalibrationHidden ) { window.calculatingAR(); }
									
									var roomSetupRunning = window.roomSetupRunningCheck();
									if ( roomSetupRunning )
										{
											this.mediaPipeFreezeCountRoomSetup++;
											
											if ( this.mediaPipeFreezeCountRoomSetup == 1 )
												{
													if ( timeDiff >= parseInt(this.whiteboardValues['mediaPipeFirstFreeze']) )
														{
															window.mediaPipeRoomSetupFail = true;
															window.skipRoomSetup(parseInt(this.id)); 
														}
													else
														{
															window['usingPose'] = false;
															setTimeout(function() {
																window['usingPose'] = true;
															}, parseInt(this.whiteboardValues['mediaPipeFreezeWait']));
														}
												}
											else if ( this.mediaPipeFreezeCountRoomSetup > 1 )
												{
													if ( timeDiff >= parseInt(this.whiteboardValues['mediaPipeFreezeWait']) )
														{
															window.mediaPipeRoomSetupFail = true;
															window.skipRoomSetup(parseInt(this.id)); 
														}
												}
										}
										
									if ( window.mediaPipeRoomSetupFail && window.mediaPipeLastTry )
										{
											window.mediaPipeLastTry = false;
											this.disableMediaPipe();
											return false;
										}
								}
							else
								{
									this.mediaPipeFreezeCount = 0;
									mainthis.whiteboard.clearMessageInstructions();
									if ( window.disableCalculatingAR ) { window.disableCalculatingAR(); }
								}
								
							if ( window.mediaPipeRoomSetupFail && window.mediaPipeLastTry )
								{
									console.log('mediaPipeLastTry success');
									window.mediaPipeLastTry = false;
								}
								
							//console.log('mediaPipeFreezeCount', this.mediaPipeFreezeCount);
								
							if ( this.turnMediaPipeOnAgain )
								{
									if ( trackerInfo['mediaPipe'].length == 0 )
										{
											this.toggleMediaPipe(true);
										}
									else
										{
											this.turnMediaPipeOnAgain = false;
										}
								}
								
							if ( this.mediaPipeFreezeCount >= parseInt(this.whiteboardValues['mediaPipeFailCount']) )
								{
									this.disableMediaPipe();
									console.log('disableMediaPipe');
									return false;
								}
							
							if ( !window['mediaPipeFirstTime'] )
								{
									window['mediaPipeFirstTime'] = true;
									this.switchToNextRoomStep();
								}
						}
						
					window.getParticipantPosition(JSON.stringify(trackerInfo));
					
					if ( window['tisRecording'] )
						{
							var nowTimeR = (new Date()).getTime();
							this.trackerData = this.trackerData + (nowTimeR-this.startRecTime) + 's : ' +Math.floor((nowTimeR-this.startRecTime)/33) +'  - ' + JSON.stringify(trackerInfo) + "\n";
						}
					
					if ( !seg )
						{
							useDefaultSegBox = true;
							
							seg = {
								'width': 200,
								'height': 120,
								'y': 120,
								'x': 200
							};
							
							//console.log('DROP VALUES SEG - ' + JSON.stringify(seg));
						}
					
					if ( seg['width'] >= this.whiteboard.bufferCanvas.width || seg['height'] >= this.whiteboard.bufferCanvas.height || seg['y'] >= this.whiteboard.bufferCanvas.height || seg['x'] >= this.whiteboard.bufferCanvas.width )
						{
							if ( seg['width'] >= this.whiteboard.bufferCanvas.width ) { seg['width'] = this.whiteboard.bufferCanvas.width - 2; }
							if ( seg['height'] >= this.whiteboard.bufferCanvas.height ) { seg['height'] = this.whiteboard.bufferCanvas.height - 2; }
							if ( seg['y'] >= this.whiteboard.bufferCanvas.height ) { seg['y'] = this.whiteboard.bufferCanvas.height - 2; }
							if ( seg['x'] >= this.whiteboard.bufferCanvas.width ) { seg['x'] = this.whiteboard.bufferCanvas.width - 2; }
							
							var nowTimeR = (new Date()).getTime();
							this.trackerData = this.trackerData + (nowTimeR-this.startRecTime) + 's : ' +Math.floor((nowTimeR-this.startRecTime)/33) +'  DROP VALUES - ' + JSON.stringify(trackerInfo) + "\n";
							
							//console.log('DROP VALUES - ' + JSON.stringify(trackerInfo));
						}
					
					var segTrackerX = seg['x'] * canvasWidthDiff;
					var segTrackerW = seg['width'] * canvasWidthDiff;
					var segTrackerY = seg['y'] * canvasHeightDiff;
					var segTrackerH = seg['height'] * canvasHeightDiff;
					
					this.partLeft = segTrackerX;
					this.partRight = segTrackerX + segTrackerW;
					this.partTop = segTrackerY;
					this.partBottom = segTrackerY + segTrackerH;
					
					this.segLeft = segTrackerX;
					this.segRight = segTrackerX + segTrackerW;
					this.segTop = segTrackerY;
					this.segBottom = segTrackerY + segTrackerH;
					this.trackerDef = true;
					
					if ( trackerInfo['foot1_row'] > 0 )
						{
							this.whiteboard.lowest_point = trackerInfo['foot1_row'] > trackerInfo['foot2_row'] ? trackerInfo['foot1_row']*canvasWidthDiff : trackerInfo['foot2_row']*canvasWidthDiff;
							this.whiteboard.lowest_pointX = trackerInfo['foot1_row'] > trackerInfo['foot2_row'] ? trackerInfo['foot1_col']*canvasWidthDiff : trackerInfo['foot2_col']*canvasWidthDiff;
						}
					else
						{
							this.whiteboard.lowest_point = this.segBottom;
							this.whiteboard.lowest_pointX = this.segRight - ((this.segRight - this.segLeft) / 2);
						}
					
					if ( window['showTrackerRectangle1'] ) { console.log('Detectors', JSON.stringify(trackerInfo)); }
					
					if ( this.whiteboard.roomSetup.viewCaptured && this.whiteboard.roomSetup.workoutAreaSetupDone && trackerInfo['detectors'] && trackerInfo['detectors'][0] && typeof trackerInfo['detectors'][0]['prev_state'] !== 'undefined' && typeof trackerInfo['detectors'][0]['state'] !== 'undefined' )
						{
							//this.checkDetectors(trackerInfo);
						}
					else
						{
							this.trackerTouched = false;
							this.trackerTouched2 = false;
							this.detectorColor2 = this.globalEquipmentObject['detectorColor'];
							this.detectorColor = this.globalEquipmentObject['detectorColor'];
							//this.whiteboard.sendNewRTMMessage('coneTouched'+this.sep+'none', 'coneTouched');
						}
					
					if ( (( window['showTrackerRectangle'] ) || this.totalTimeRestart >= 2) && !useDefaultSegBox )
						{
							this.drawBoundingBox(trackerInfo, canvasWidthDiff);
						}
				}

			if ( this.whiteboard.clearPoints.length == 0 || !this.whiteboard.lowest_point || Object.keys(this.whiteboard.bodyX).length == 0 ) { this.alreadyIsChecking = false; return false; }
			var leftX = Object.keys(this.whiteboard.bodyX)[0];
			var rightX = Object.keys(this.whiteboard.bodyX)[Object.keys(this.whiteboard.bodyX).length - 1];
				
			if ( !this.electron )
				{
					window['showTrackerRectangle'] = true;
					if ( window['showTrackerRectangle'] )
						{
							this.partLeft = leftX;
							this.partRight = rightX;
							this.partTop = this.whiteboard.clearPoints[this.whiteboard.clearPoints.length-1][1];
							this.partBottom = this.whiteboard.lowest_point;
							
							this.drawBoundingBox(false, canvasWidthDiff);
						}
				}
			this.alreadyIsChecking = false;
		}
		
	trackerMovement = () => 
		{
			if ( !this.guestUser && !this.hostVirtual && !this.onDemand ) { return false; }
			if ( !this.tracker || (this.tracker && !this.tracker.movement_in_region) ) { return false; }
			
			var pixelBuff = this.whiteboard.ctx4.getImageData(0, 0, this.whiteboard.bufferCanvas.width, this.whiteboard.bufferCanvas.height);
			
			var uint8ClampedArray = pixelBuff.data;
			this.whiteboard.arrayBuffer = uint8ClampedArray.buffer;
			var trackerMove = '';
			try 
			{
				trackerMove = this.tracker.movement_in_region(this.whiteboard.arrayBuffer);
			}
			catch (err)
			{
				console.error('TRACKER ERROR --');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
			return trackerMove;
		}
		
	setTrackerRegion(trackerRegion) 
		{
			if ( !this.tracker || (this.tracker && !this.tracker.set_region) ) { return false; }
			
			if ( trackerRegion['x'] < 20 ) { trackerRegion['x'] = 20; }
			if ( trackerRegion['x'] + trackerRegion['width'] > 620 ) { trackerRegion['width'] = 640 - trackerRegion['x'] - 20; }
			
			console.log('setTrackerRegion', trackerRegion);
			try 
			{
				this.tracker.set_region(trackerRegion);
			}
			catch (err)
			{
				console.error('TRACKER ERROR --');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
			if ( window['tisRecording'] )
				{
					var nowTimeR = (new Date()).getTime();
					this.trackerData = this.trackerData + (nowTimeR-this.startRecTime) + ' - REGION ZONE - ' + JSON.stringify(trackerRegion) + "\n";
				}
		}
		
	drawBoundingBox(trackerInfo, canvasWidthDiff)
		{
			/* if ( this.electron )
				{
					this.whiteboard.ctx.beginPath();
					this.whiteboard.ctx.moveTo(this.segLeft, this.segBottom);
					this.whiteboard.ctx.lineTo(this.segRight, this.segBottom);
					this.whiteboard.ctx.moveTo(this.segLeft, this.segTop);
					this.whiteboard.ctx.lineTo(this.segRight, this.segTop);
					this.whiteboard.ctx.moveTo(this.segLeft, this.segTop);
					this.whiteboard.ctx.lineTo(this.segLeft, this.segBottom);
					this.whiteboard.ctx.moveTo(this.segRight, this.segTop);
					this.whiteboard.ctx.lineTo(this.segRight, this.segBottom);
					this.whiteboard.ctx.strokeStyle = 'blue';
					this.whiteboard.ctx.lineWidth = 7;
					this.whiteboard.ctx.stroke();
					this.whiteboard.ctx.closePath();
					
					//draw feet
					this.whiteboard.ctx.beginPath();
					this.whiteboard.ctx.strokeStyle = 'green';
					this.whiteboard.ctx.strokeRect(trackerInfo['foot1_col']*canvasWidthDiff, trackerInfo['foot1_row']*canvasWidthDiff, 10, 10);
					this.whiteboard.ctx.strokeRect(trackerInfo['foot2_col']*canvasWidthDiff, trackerInfo['foot2_row']*canvasWidthDiff, 10, 10);
					this.whiteboard.ctx.closePath();
				}
			else
				{				
					this.whiteboard.ctx.beginPath();
					this.whiteboard.ctx.moveTo(this.partLeft, this.partBottom);
					this.whiteboard.ctx.lineTo(this.partRight, this.partBottom);
					this.whiteboard.ctx.moveTo(this.partLeft, this.partTop);
					this.whiteboard.ctx.lineTo(this.partRight, this.partTop);
					this.whiteboard.ctx.moveTo(this.partLeft, this.partTop);
					this.whiteboard.ctx.lineTo(this.partLeft, this.partBottom);
					this.whiteboard.ctx.moveTo(this.partRight, this.partTop);
					this.whiteboard.ctx.lineTo(this.partRight, this.partBottom);
					this.whiteboard.ctx.strokeStyle = 'red';
					this.whiteboard.ctx.lineWidth = 7;
					this.whiteboard.ctx.stroke();
					this.whiteboard.ctx.closePath();
				} */
		}
	
	async checkFeetTracker(trackerInfo, canvasHeightDiff, canvasWidthDiff)
		{
			this.trackerStandInZone = trackerInfo['in_zone'];
			let mainThis = this;	
			if ( ( ( !window.isPaused && ( this.whiteboard.globalActType == 'ladder' || this.whiteboard.globalActType == 'boxJump' || this.whiteboard.globalActType == 'reactionDrill' || this.whiteboard.globalActType == 'resistedSideStepping' ) ) || this.whiteboard.roomSetup.workoutAreaProcess ) )
				{
					//console.log('Checking pose ZONE', new Date().getTime());
					//if ( this.whiteboard.useMediaPipe ) { this.trackerStandInZone = await this.whiteboard.poseDetection.checkInZone(this.whiteboard.bufferCanvas); }
					//console.log('Checking pose ZONE', new Date().getTime(), this.trackerStandInZone);
				}
			
			this.left_extrema = {
				'row': 0,
				'col': 0
			}
			this.right_extrema = {
				'row': 0,
				'col': 0
			}
			
			if ( trackerInfo['left_extrema'] && trackerInfo['right_extrema'] )
				{
					trackerInfo['left_extrema'].forEach(function(item, index) {
						if ( item['row'] > mainThis.left_extrema['row'] )
							{
								mainThis.left_extrema = {
									'row': item['row']*canvasHeightDiff,
									'col': item['col']*canvasWidthDiff
								};
							}
					});
					
					trackerInfo['right_extrema'].forEach(function(item, index) {
						if ( item['row'] > mainThis.right_extrema['row'] )
							{
								mainThis.right_extrema = {
									'row': item['row']*canvasHeightDiff,
									'col': item['col']*canvasWidthDiff
								};
							}
					});
				}
		}
	
	drawDetectorsLine()
		{
			if ( !this.whiteboard.globalActType || ( this.whiteboard.globalActType && !this.whiteboard.roomSetup.workoutAreaSetupDone ) ) { return false; }
			let mainthis = this;
			if ( this.detectorSet && this.whiteboard.showDetectorsLine )
				{
					this.detectorSet.forEach(function(det, i) {
						mainthis.whiteboard.ctx.beginPath();
						mainthis.whiteboard.ctx.moveTo(det['col0']*mainthis.canvasTrackerWidth, det['row0']*mainthis.canvasTrackerWidth);
						mainthis.whiteboard.ctx.lineTo(det['col0']*mainthis.canvasTrackerWidth, det['row1']*mainthis.canvasTrackerWidth);
						mainthis.whiteboard.ctx.strokeStyle = mainthis.detectorColor;
						mainthis.whiteboard.ctx.lineWidth = 7*mainthis.whiteboard.canvasRatio;
						mainthis.whiteboard.ctx.stroke();
						mainthis.whiteboard.ctx.closePath();
					});
				}
		}
		
	setDetectorBackground() 
		{
			let mainThis = this;
			
			if ( this.electron && (this.whiteboard.roomSetup.viewCaptured && this.whiteboard.roomSetup.workoutAreaSetupDone) && !this.pauseDetectorBackground && ( this.guestUser || this.onDemand || this.hostVirtual ) )
				{
					console.log('setDetectorBackground inside');
					/* if ( ((this.trackerX > this.partLeft && this.trackerX < this.partRight) || (this.trackerXL > this.partLeft && this.trackerX < this.partRight)) && !window['workoutAreaProcess'+this.id] )
						{
							console.log('BEHIND DETECTOR');
							this.pauseDetectorBackground = true;
							
							setTimeout(function(){
								mainThis.pauseDetectorBackground = false;
							}, 2000);
						}
					else
						{ */
							var bufferDraw = this.whiteboard.ctx4.drawImage(this.whiteboard.imageCanvas,0,0,this.whiteboard.bufferCanvas.width,this.whiteboard.bufferCanvas.height);
							var pixelBuff = this.whiteboard.ctx4.getImageData(0, 0, this.whiteboard.bufferCanvas.width, this.whiteboard.bufferCanvas.height);
							var uint8ClampedArray = pixelBuff.data;
							this.whiteboard.arrayBuffer = uint8ClampedArray.buffer;
							console.log('tracker_info --> SET DETECTOR BACKGROUND IMAGE BEFORE 2');
							try
							{
								this.tracker.set_detector_bkg_image(this.whiteboard.arrayBuffer);
							}
							catch (err)
							{
								console.error('TRACKER ERROR --- SET DETECTOR BACKGROUND');
								console.error(err);
								window.$('#tracker-error').modal('show');
								this.trackerBorken = true;
								//window['saveCurrentCanvasAsPNG']('crash');
							}

							//window['saveCurrentCanvasAsPNG']('detector');
							
							console.log('tracker_info --> SET BACKGROUND IMAGE 2');
							this.setTrackerBackground = true;
							if ( window.isPaused && !this.onDemand )
								{
									this.finalPositionTimeout = setTimeout(function(){
										if ( window['allowGettingPosition'] )
											{
												window['globalRTM'](window['currentUserData']['sessionData']['hostEmail'], 'finalPosition'+mainThis.sep);	
												window['inFinalPosition'] = true;
											}
									}, 4000);
								}
						/* } */
				}
		}
	
	trackerInitialize() 
		{
			if ( !this.whiteboard.globalActType ) { return false; }
			var json_from_database = {};
			var trackerActJSON = this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['trackerInitialize'];
			var trackerString = this.whiteboardValues[trackerActJSON];
			json_from_database = JSON.parse(trackerString);

			try
			{
				this.tracker.set_side_velocity_limits(json_from_database);
				console.log('tracker_info --> SET ACC LIMITS', json_from_database);
			}
			catch (err)
			{
				console.error('TRACKER ERROR --');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
			this.trackerInitialized = true;
		}
	
	setTrackerSides() 
		{
			if ( !this.whiteboard.globalActType ) { return false; }
			if ( !this.tracker || (this.tracker && !this.tracker.set_sides) ) { return false; }
			
			var number1, number2;
			var trackerSideNumbers = this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['trackerSideNumbers'];
			var canvasWidthDiff = 640 / this.whiteboard.canvas.width;
			
			number1 = Math.round(this.whiteboard.participantHeight2*trackerSideNumbers[0]*canvasWidthDiff);
			number2 = Math.round(this.whiteboard.participantHeight2*trackerSideNumbers[1]*canvasWidthDiff);
			
			try 
			{
				this.tracker.set_sides(number1, number2);
				console.log('tracker_info --> SET SIDES', number1, number2);
			}
			catch (err)
			{
				console.error('TRACKER ERROR --');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
		}
		
	setTrackerZone = (spec) =>
		{
			if ( !this.tracker || (this.tracker && !this.tracker.set_quadrilateral_zone) ) { return false; }
			
			if ( spec['lr_row'] > 340 )
				{
					spec['lr_row'] = 340;
					spec['ll_row'] = 340;
				}
		
			if ( spec['lr_col'] > 630 )
				{
					spec['lr_col'] = 630;
					spec['ur_col'] = 630;
				}
		
			spec['ul_col'] = spec['ul_col'] < 20 ? 20 : spec['ul_col'];
			spec['ur_col'] = spec['ur_col'] < 20 ? 20 : spec['ur_col'];
			spec['lr_col'] = spec['lr_col'] < 20 ? 20 : spec['lr_col'];
			spec['ll_col'] = spec['ll_col'] < 20 ? 20 : spec['ll_col'];
			
			try 
			{
				this.tracker.set_quadrilateral_zone(spec);
			}
			catch (err)
			{
				console.error('TRACKER ERROR --');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
			
			if ( this.whiteboard.useMediaPipe ) { this.whiteboard.poseDetection.updateQuatZone(spec); }
			
			if ( window['tisRecording'] )
				{
					var nowTimeR = (new Date()).getTime();
					this.trackerData = this.trackerData + (nowTimeR-this.startRecTime) + ' - QUAD ZONE - ' + JSON.stringify(spec) + "\n";
				}
				
			console.log('SET NEW ZONE SPEC', spec);
		}
		
	setTrackerZoneAndRegion = (zone, region) =>
		{
			if ( !this.guestUser && !this.hostVirtual && !this.onDemand ) { return false; }
			
			if ( region )
				{
					this.setTrackerRegion(region, true);
					console.log('trackerRegion', region);
				}
			
			if ( zone )
				{
					var spec = {
						"ul_row": Math.round(zone['topSide']/this.canvasTrackerWidth), "ul_col": Math.round(zone['leftSideOfSpace']/this.canvasTrackerWidth),
						"ur_row": Math.round(zone['topSide']/this.canvasTrackerWidth), "ur_col": Math.round(zone['rightSideOfSpace']/this.canvasTrackerWidth),
						"lr_row": Math.round(zone['bottomSide']/this.canvasTrackerWidth), "lr_col": Math.round(zone['rightSideOfSpace']/this.canvasTrackerWidth),
						"ll_row": Math.round(zone['bottomSide']/this.canvasTrackerWidth), "ll_col": Math.round(zone['leftSideOfSpace']/this.canvasTrackerWidth)
					};
					
					this.setTrackerZone(spec);
				}
		}
		
	setBackgroundImage = (image) =>
		{
			//console.log('setBackgroundImage 111');
			if ( !this.guestUser && !this.hostVirtual && !this.onDemand ) { return false; }
			if ( !this.tracker || (this.tracker && !this.tracker.set_bkg_image) ) { return false; }
			
			//console.log('setBackgroundImage 222');
			
			var bufferDraw = this.whiteboard.ctx4.drawImage(image,0,0,this.whiteboard.bufferCanvas.width,this.whiteboard.bufferCanvas.height);
			var pixelBuff = this.whiteboard.ctx4.getImageData(0, 0, this.whiteboard.bufferCanvas.width, this.whiteboard.bufferCanvas.height);
			var uint8ClampedArray = pixelBuff.data;
			//console.log('setBackgroundImage 333');
			this.whiteboard.arrayBuffer = uint8ClampedArray.buffer;
			//console.log('tracker_info --> SET BACKGROUND IMAGE BEFORE');
			try 
			{
				this.tracker.set_bkg_image(this.whiteboard.arrayBuffer);
			}
			catch (err)
			{
				console.error('TRACKER ERROR --');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
			this.isTrackerBgSet = true;
			//console.log('setBackgroundImage 444');
			this.whiteboard.saveCurrentCanvasAsPNG('first');
			//console.log('setBackgroundImage 555');
		}
	
	calculateDetectorsPosition = () =>
		{
			if ( !this.whiteboard.globalActType ) { return false; }
			let drawingObjects = this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['drawingObjects'];
			
			this.detectorSet = [];
			this.detectorSetInfo = [];
			let mainthis = this;
			drawingObjects.forEach(function(item, index) {
				var imageObject = mainthis.whiteboard.getImageObject(item, false);
				var detectors = item['detectors'];
				var detY1 = 0;
				var detY2 = 0;
				var detX = 0;
				
				detectors.forEach(function(det, i) {
					if ( det['relativeTo'] == 'image' )
						{
							// calculate detector X
							detX = mainthis.calculatePosition(det['x1'], imageObject, imageObject['x']);
							
							// calculate detector Y1
							detY1 = mainthis.calculatePosition(det['y1'], imageObject, imageObject['y']);
							
							// calculate detector Y2
							detY2 = mainthis.calculatePosition(det['y2'], imageObject, imageObject['y']);
						}
						
					mainthis.detectorSet.push({
						"col0": Math.round(detX*mainthis.canvasWidthTracker),
						"row0": Math.round(detY1*mainthis.canvasWidthTracker),
						"row1": Math.round(detY2*mainthis.canvasWidthTracker),
						"num": det['detectorNum'],
						"spacing": det['detectorSpacing'],
						"side": det['side']
					});
					mainthis.detectorSetInfo.push([index, i]);
				});
				
			});
		}
	
	setDetectors = () =>
		{
			this.calculateDetectorsPosition();
			
			if ( !this.guestUser && !this.hostVirtual && !this.onDemand ) { return false; }
			if ( !this.tracker || (this.tracker && !this.tracker.set_detectors) ) { return false; }
			
			if ( this.detectorSet )
				{
					try
					{
						console.log('setDetectors detectorSet');
						console.log(this.detectorSet);
						console.log('setDetectors tracker');
						console.log(this.tracker);
						this.tracker.set_detectors(this.detectorSet);
					}
					catch (err)
					{
						console.error('TRACKER ERROR -- SET DETECTORS');
						console.error(err);
						window.$('#tracker-error').modal('show');
						this.trackerBorken = true;
					}
					
					this.setTrackerBackground = false;
					this.setDetectorBackground();
				}
		}
	
	calculatePosition = (item, imageObject, defaultStart) =>
		{
			var newNum = 0;
			if ( item['start'] == 0 )
				{
					newNum = defaultStart;
				}
			else if ( item['start'] == 'imageHeight' )
				{
					newNum = defaultStart + imageObject['h'];
				}
			else if ( item['start'] == 'imageWidth' )
				{
					newNum = defaultStart + imageObject['w'];
				}
			
			if ( item['change'] != 'none' )
				{
					var relativeTo = 0;
					if ( item['relative'] == 'imageWidth' )
						{
							relativeTo = imageObject['w'];
						}
					else if ( item['relative'] == 'imageHeight' )
						{
							relativeTo = imageObject['h'];
						}
					
					if ( item['change'] == 'multiply' )
						{
							newNum = newNum + (item['num'] * relativeTo)
						}
					else if ( item['change'] == 'add' )
						{
							newNum = newNum + item['num']
						}
				}
			return newNum;
		}
	
	checkDetectors = (trackerReturn) =>
		{
			var mediaPipeCheck = false;
			let mainthis = this;
			var crossingReturn = -1;
			if ( mainthis.whiteboard.useMediaPipe )
				{
					mainthis.whiteboard.poseDetection.checkDetection(mainthis.whiteboard.bufferCanvas, mainthis.detectorSet).then((crossingReturn)=>{
						mainthis.detectorSet.forEach(function(det, i) {
							var isDetectionGood = crossingReturn == -1 ? -1 : crossingReturn[i];
							
							if ( ( trackerReturn.detectors[i]['prev_state'] == 0 && trackerReturn.detectors[i]['state'] == 1 && isDetectionGood == -1 ) || ( isDetectionGood && isDetectionGood != -1 ) )
								{
									mainthis.callDetectorAction(det, i);
								}
						});
						
					});
				}
			else
				{
					this.detectorSet.forEach(function(det, i) {
						if ( trackerReturn && trackerReturn.detectors && trackerReturn.detectors[i] )
							{
								if ( trackerReturn.detectors[i]['prev_state'] == 0 && trackerReturn.detectors[i]['state'] == 1 )
									{
										mainthis.callDetectorAction(det, i);
									}
							}
					});
				}
		}
		
	callDetectorAction = (det, i) =>
		{
			var detectorObject = this.getCurrentDetector(i);
			var globalObject = this.whiteboard.getCurrentObject();
			let mainthis = this;
			if ( detectorObject && globalObject )
				{
					var isTouched = true;
					
					// Check by touch condition
					
					if ( detectorObject['detectCondition'] && detectorObject['detectCondition'][0] && globalObject['customVariables'] )
						{
							if ( globalObject['customVariables'][detectorObject['detectCondition'][0]] !== detectorObject['detectCondition'][1] )
								{
									isTouched = false;
								}
						}
					
					// Check is same as last one
					if ( globalObject['singleLastTouchIndex'] == i )
						{
							if ( globalObject['singleDetector'] == false )
								{
									isTouched = false;
								}
							else if ( globalObject['singleDetectorDelay'] > 0 )
								{
									var sinceLastTouch = new Date().getTime() - globalObject['singleLastTouchTime'];
									if ( globalObject['singleDetectorDelay'] > sinceLastTouch )
										{
											isTouched = false;
										}
								}
						}
					
					// Check is passed touch condition and does it have at least one touch action
					if ( isTouched && detectorObject['detectAction'] && detectorObject['detectAction'][0] )
						{
							var actAudioPlay;
							mainthis.updateLastIndexTouch(i);
							detectorObject['detectAction'].forEach(function (itm, indx)
								{
									if ( itm['action'] == 'changeActive' )
										{
											mainthis.changeActiveObject(itm['value']);
										}
									else if ( itm['action'] == 'changeArrows' )
										{
											mainthis.changeArrows(itm['name'], itm['value']);
										}
									else if ( itm['action'] == 'counter' )
										{
											mainthis.whiteboard.changeGlobalCounter(itm['name'], itm['value']);
											mainthis.whiteboard.calculatePerMinuteCounter();
										}
									else if ( itm['action'] == 'audio' )
										{
											actAudioPlay = globalObject['audio'][itm['name']];
											mainthis.whiteboard.soundPlay.playAudio(actAudioPlay);
										}
								});
						}
				}
		}
	
	getCurrentDetector = (ind) =>
		{
			if ( this.whiteboard.activityBuilderContent &&
				this.detectorSetInfo[ind] &&
				this.detectorSetInfo[ind].length == 2 &&
				this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType] &&
				this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['drawingObjects'] &&
				this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['drawingObjects'][this.detectorSetInfo[ind][0]] &&
				this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['drawingObjects'][this.detectorSetInfo[ind][0]]['detectors'] &&
				this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['drawingObjects'][this.detectorSetInfo[ind][0]]['detectors'][this.detectorSetInfo[ind][1]] )
					{
						return this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['drawingObjects'][this.detectorSetInfo[ind][0]]['detectors'][this.detectorSetInfo[ind][1]];
					}
			
			return false;
		}
		
	changeActiveObject = (change_index) =>
		{
			if ( !this.whiteboard.globalActType ) { return false; }
			let mainthis = this;
			let drawingObjects = this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['drawingObjects'];
			drawingObjects.forEach(function(item, index) {
				if ( index == change_index )
					{
						mainthis.whiteboard.activityBuilderContent.activityBuilderObject[mainthis.whiteboard.globalActType]['drawingObjects'][index]['isActive'] = true;
					}
				else
					{
						mainthis.whiteboard.activityBuilderContent.activityBuilderObject[mainthis.whiteboard.globalActType]['drawingObjects'][index]['isActive'] = false;
					}
			});
		}
	
	changeArrows = (name, val) =>
		{
			if ( !this.whiteboard.globalActType ) { return false; }
			
			if ( this.whiteboard.activityBuilderContent &&
				this.whiteboard.globalActType &&
				this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType] &&
				this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['drawArrows'] &&
				this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['drawArrows'][0][name] )
					{
						this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['drawArrows'][0][name] = val;
					}
		}
	
	updateLastIndexTouch = (change_index) =>
		{
			if ( !this.whiteboard.globalActType ) { return false; }
			
			if ( this.whiteboard.activityBuilderContent &&
				this.whiteboard.globalActType &&
				this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType] )
					{
						this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['singleLastTouchIndex'] = change_index;
						this.whiteboard.activityBuilderContent.activityBuilderObject[this.whiteboard.globalActType]['singleLastTouchTime'] = new Date().getTime();
					}
		}
		
	setRegion = (trackerRegion) =>
		{
			if ( !this.guestUser && !this.hostVirtual && !this.onDemand ) { return false; }
			if ( !this.tracker || (this.tracker && !this.tracker.set_region) ) { return false; }
			
			if ( typeof trackerRegion == 'string' ) { trackerRegion = JSON.parse(trackerRegion); }
			console.log('setRegion', trackerRegion);
			
			try 
			{
				this.tracker.set_region(trackerRegion);
			}
			catch (err)
			{
				console.error('TRACKER ERROR --');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
		}
		
	setQuadTrackerZone = (spec) =>
		{
			if ( !this.guestUser && !this.hostVirtual && !this.onDemand ) { return false; }
			if ( !this.tracker || (this.tracker && !this.tracker.set_quadrilateral_zone) ) { return false; }
			
			if ( typeof spec == 'string' ) { spec = JSON.parse(spec); }
			console.log('setQuadTrackerZone', spec);
			try 
			{
				this.tracker.set_quadrilateral_zone(spec);
			}
			catch (err)
			{
				console.error('TRACKER ERROR --');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
			if ( this.whiteboard.useMediaPipe ) { this.whiteboard.poseDetection.updateQuatZone(spec); }
		}
	
	trackerSetSides = (num1, num2) =>
		{
			if ( !this.tracker || (this.tracker && !this.tracker.set_sides) ) { return false; }
			
			try
			{
				this.tracker.set_sides(num1, num2);
			}
			catch (err)
			{
				console.error('TRACKER ERROR -- ');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
		}
	
	setDetectorsPosition = (detectorSet) =>
		{
			if ( !this.tracker || (this.tracker && !this.tracker.set_detectors) ) { return false; }
			
			var detectorSetVal = JSON.parse(detectorSet);
			try
			{
				console.log('setDetectorsPosition detectorSet');
				console.log(detectorSet);
				console.log('setDetectorsPosition tracker');
				console.log(this.tracker);
				this.tracker.set_detectors(detectorSetVal);
			}
			catch (err)
			{
				console.error('TRACKER ERROR -- SET DETECTORS POSITION');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
		}
	
	setBackgroundDetector = () =>
		{
			if ( !this.tracker || (this.tracker && !this.tracker.set_detector_bkg_image) ) { return false; }
			
			var bufferDraw = this.whiteboard.ctx4.drawImage(this.whiteboard.imageCanvas,0,0,this.whiteboard.bufferCanvas.width,this.whiteboard.bufferCanvas.height);
			var pixelBuff = this.whiteboard.ctx4.getImageData(0, 0, this.whiteboard.bufferCanvas.width, this.whiteboard.bufferCanvas.height);
			var uint8ClampedArray = pixelBuff.data;
			this.whiteboard.arrayBuffer = uint8ClampedArray.buffer;
			console.log('tracker_info --> SET DETECTOR BACKGROUND IMAGE BEFORE 2');
			try
			{
				this.tracker.set_detector_bkg_image(this.whiteboard.arrayBuffer);
			}
			catch (err)
			{
				console.error('TRACKER ERROR -- SET BACKGROUND DETECTOR');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
		}
		
	trackerSetSideLimits = (sideLimit) =>
		{
			if ( !this.tracker || (this.tracker && !this.tracker.set_side_velocity_limits) ) { return false; }
			
			try 
			{
				this.tracker.set_side_velocity_limits(sideLimit);
			}
			catch (err)
			{
				console.error('TRACKER ERROR --');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
		}
		
	setImageBackground = (image) =>
		{
			if ( !this.tracker || (this.tracker && !this.tracker.set_bkg_image) ) { return false; }
			
			var bufferDraw = this.whiteboard.ctx4.drawImage(image,0,0,this.whiteboard.bufferCanvas.width,this.whiteboard.bufferCanvas.height);
			var pixelBuff = this.whiteboard.ctx4.getImageData(0, 0, this.whiteboard.bufferCanvas.width, this.whiteboard.bufferCanvas.height);
			var uint8ClampedArray = pixelBuff.data;
			this.whiteboard.arrayBuffer = uint8ClampedArray.buffer;
			console.log('tracker_info --> SET BACKGROUND IMAGE BEFORE');
			try 
			{
				this.tracker.set_bkg_image(this.whiteboard.arrayBuffer);
			}
			catch (err)
			{
				console.error('TRACKER ERROR --');
				console.error(err);
				window.$('#tracker-error').modal('show');
				this.trackerBorken = true;
			}
		}
		
	setImageBackgroundFromCanvas = () =>
		{
			var backgroundImage = this.whiteboard.imageCanvas;
			this.setBackgroundImage(backgroundImage);
		}
		
	checkInZoneMediaPipe = async () =>
		{
			if ( this.whiteboard.useMediaPipe ) { this.trackerStandInZone = await this.whiteboard.poseDetection.checkInZone(this.whiteboard.bufferCanvas); }
			return this.trackerStandInZone
		}
		
	disableMediaPipe = () =>
		{
			var mainthis = this;
			window['poseSegmentationMask'] = false;
			window['poseDots'] = [];
			window.disableDetection(parseInt(this.id));
			this.trackerBorken = true;
			window.detectionDisabled = true;
			
			if ( window['preStreamingWhite'] && !this.whiteboard.roomSetup.workoutAreaSetupDone ) 
				{ 
					window.skipRoomSetup(parseInt(this.id)); 
					window.stopAudio();
					window.playAudio('mediaFail');
				}
			
			this.whiteboard.showMessageInstruction('We continue to encounter issues with your setup for Virtual activities, turning off detection');
			
			setTimeout(function() {
				mainthis.whiteboard.clearMessageInstructions();
				if ( window['preStreamingWhite'] ) { window.enterSession(); }
			}, 5000);
		}

	toggleMediaPipe = (mediaPipeOff) =>
		{	
			var mainthis = this;
			console.log('toggleMediaPipe', mediaPipeOff);
			
			if ( mediaPipeOff )
				{
					//window['setBigTrackerZone']();
					window['poseDots'] = [];
					window['poseSegmentationMask'] = false;
					var recalibrationHidden = JSON.parse(localStorage.getItem('recalibrationHidden')).value;
					if ( window.calculatingAR && !recalibrationHidden ) { window.calculatingAR(); }
					this.turnMediaPipeOnAgain = true;
					
					if ( this.mediaPipeToggleTimeout ) { clearTimeout(this.mediaPipeToggleTimeout); }
					
					this.mediaPipeToggleTimeout = setTimeout(function() {
						mainthis.toggleMediaPipe(false);
					}, this.whiteboardValues.mediaPipeTurnOnTimeout);
				}
			
			this.turnOffMediaPipe = mediaPipeOff;
		}
		
	pauseMediaPipe = () =>
		{
			window['usingPose'] = false;
			window['poseDots'] = [];
			window['poseSegmentationMask'] = false;
		}
		
	switchToNextRoomStep = () =>
		{
			this.whiteboard.clearMessageInstructions();
			if ( window.roomSetupNextStep ) { window.roomSetupNextStep(); }
			window.$('#partBigCounter').addClass('d-none');
			setTimeout(function () { window['allowLineCalling'](); }, 4000);
		}
}

export default trackerActions;